<!--src/Components/Navbar/Navbar.svelte-->
<script>
  import { onMount } from "svelte";
  import { store } from '../../store.js';

  let x, y;
  export let r;
  export let logo;

  export let navlists = [];

  function handleLanguage(locale) {
    let paths = location.pathname.split('/');

    if(paths.length >= 2) {
      paths[1] = locale;
      location.href = paths.join('/');
      return;
    }

    location.href = '/';
}

  
</script>

<!------------------------------------------->
<!----------------MARKUP----------------------->
<!------------------------------------------->
<svelte:window bind:scrollY={y} bind:innerWidth={x} />

<section id="nav-bar">
  {#if logo}
  <a class="text-dark navbar-brand company_brand" class:hidden={y >= 100} href={$store.locale ? `/${$store.locale}` : '/'} style={`top: ${($store.r * 35)}px; left: ${($store.r * 45)}px`}>
      <img 
        style={`width: ${($store.r * 300)}px`}
        src="/images/mobile-logo.png" 
        alt="" 
        class="logo m-auto" 
      />      
  </a>
  {/if}
  <nav class="navbar navbar-expand-lg navbar-light" style={`padding-top: ${($store.r * 50)}px`}>
    <div class="container-fluid justify-content-end p-0">
      <button id="toggler" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse p-0" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          {#each navlists as list}
            <li class="nav-item">
              <a class="nav-link text-dark" href={`/${$store.locale || 'en'}${list.url}`} on:click={list.onClick || null}>
                {`${list.label}`}
              </a>
            </li>
          {/each}
          <a href={"/wp/{$store.locale}/Konnect_White_Paper_v{$store.wpVersion}.pdf"} class="contact nav-link text-dark" style={`margin-right: ${($store.r * 20)}px !important;`}>
            Whitepaper
          </a>
          <a href="/{$store.locale}#contact" class="contact nav-link text-dark" style={`margin-right: ${($store.r * 20)}px !important;`}>
            Contact Us
          </a>

          <div class="d-flex justify-content-center">
            <a class="" href="/en">
              <img src="/images/flags/american_flag.png" alt="" class="logo m-auto" style={`width: ${($store.r * 40)}px !important;`} />    
            </a>

            <a class="" href="/kr">
              <img src="/images/flags/korean_flag.png" alt="" class="logo m-auto" style={`width: ${($store.r * 40)}px !important;`} />    
            </a>

            <a class="" href="/vn">
              <img src="/images/flags/vietnam_flag.png" alt="" class="logo m-auto" style={`width: ${($store.r * 40)}px !important;`} />    
            </a>
          </div>
        </ul>
      </div>
    </div>
  </nav>
</section>
<!------------------------------------------->
<!----------------STYLE----------------------->

<!------------------------------------light-color------->
<style>
  .contact {
    border: 1px solid #333;
    border-radius: 20px;
    padding: 3px 10px !important;
    font-size: 2.5vw !important;
    cursor: pointer;
  }
  .hidden {
    display: none !important;
  }
  #toggler {
    font-size: 5vw;
    border: none;
    padding: 0;
    margin-right: 30px;
  }
  .company_brand {
    position: absolute;
    display: flex;
    font-family: 'KoHo', sans-serif !important;
    font-weight: bold;
    gap: 0px 10px;
    align-items:center;/*Vertical align*/
    justify-content:center;/*horizontal align*/
    font-size: 30px;
    top: 50px;
    left: 80px;
  }
  .dropdown-menu {
    background-color: transparent;
    border: none;
  }

  #nav-bar {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    /* background-color: #fff; */
  }

  .navbar {
    padding: 0;
    width: 100%;
    margin: auto;
    /* padding-left: 20% !important;
    padding-right: 20% !important; */
  }

  .navbar-nav {
    align-items: center;
    font-size: 3vw;
    font-weight: 300;
  }

  #navbarNav ul {
    font-size: 3vw;
    width: 40%;
    gap: 20px;
    margin-right: 0 !important;
    margin-left: auto;
    background: #ffffffe0;
    padding: 20px;
    border-radius: 10px;
  }

  .navbar-nav li {
    text-align: left;
    /* width: calc(100%/7) */
  }

  .navbar-nav li a {
    padding: 0;
    font-weight: 600;
  }

  .logo {
    /* width: 140px; */
    /* margin-left: 20px; */
  }

  .dropdown:hover > .dropdown-menu {
    display: block;
    font-size: 15px;
  }
</style>

